import { motion } from 'framer-motion'
import { TrendingUp, RefreshCw } from 'lucide-react'
import { Link } from 'react-router-dom'
import { useLocalFeed } from '../hooks/useLocalFeed'
import { EntryCard } from '../components/Entry/EntryCard'
import { AgendaCloud } from '../components/Entry/AgendaCloud'

export function HomePage() {
  // Tüm Mavililer entry'lerini çek (karışık başlıklardan)
  const { localEvents, isLoading, refetch } = useLocalFeed(50)

  const mappedEntries = localEvents.map(event => {
    // NIP-14: Extract subject tag (original topic title)
    const subjectTag = event.tags.find(tag => tag[0] === 'subject')?.[1]

    // Fallback: Get from hashtags if subject tag not found
    const hashtags = event.tags.filter(tag => tag[0] === 't').map(tag => tag[1])
    const hashtagTopic = hashtags.find(tag => tag !== 'mavililer' && tag !== 'mavililersözlük' && tag !== 'nostr' && tag !== 'türkiye')

    // Use subject tag first, then hashtag, then default
    const topicTitle = subjectTag || (hashtagTopic ? hashtagTopic.replace(/-/g, ' ') : 'gündem')

    return {
      id: event.id,
      content: event.content,
      created_at: new Date(event.created_at * 1000).toISOString(),
      author_pubkey: event.pubkey,
      topicTitle: topicTitle, // Now with NIP-14 subject tag support!
      author_username: event.pubkey.slice(0, 8),
      author_avatar_url: null,
      author_reputation: 0,
      upvotes: 0,
      downvotes: 0,
    }
  })

  return (
    <motion.div
      initial={{ opacity: 0, y: 20 }}
      animate={{ opacity: 1, y: 0 }}
      transition={{ duration: 0.5 }}
      className="space-y-6"
    >

      {/* Agenda Tag Cloud */}
      <AgendaCloud />

      {/* Entry Akışı - Karışık Başlıklardan */}
      <div className="space-y-4">
        <div className="flex items-center justify-between mb-6">
          <div className="flex items-center gap-2">
            <TrendingUp className="w-5 h-5 text-mavi-500" />
            <h2 className="font-poppins font-semibold text-xl text-gray-900 dark:text-white">
              ortaya karışık
            </h2>
          </div>
          <button
            onClick={refetch}
            disabled={isLoading}
            className="p-2 rounded-lg hover:bg-surface-100 dark:hover:bg-surface-800 transition-colors text-gray-500 hover:text-mavi-500 disabled:opacity-50"
            title="Yenile"
          >
            <RefreshCw className={`w-4 h-4 ${isLoading ? 'animate-spin' : ''}`} />
          </button>
        </div>

        {isLoading ? (
          <div className="space-y-4">
            {[...Array(5)].map((_, i) => (
              <div key={i} className="animate-pulse">
                <div className="bg-white dark:bg-surface-900 rounded-2xl p-6 border border-surface-200 dark:border-surface-700">
                  <div className="h-6 bg-surface-200 dark:bg-surface-700 rounded mb-3"></div>
                  <div className="h-4 bg-surface-200 dark:bg-surface-700 rounded w-3/4 mb-2"></div>
                  <div className="h-4 bg-surface-200 dark:bg-surface-700 rounded w-1/2"></div>
                </div>
              </div>
            ))}
          </div>
        ) : (
          <motion.div
            initial={{ opacity: 0 }}
            animate={{ opacity: 1 }}
            className="space-y-4"
          >
            {mappedEntries.map((entry) => (
              <EntryCard key={entry.id} entry={entry} hideTopicHeader={false} fetchReactions={true} />
            ))}

            {mappedEntries.length === 0 && (
              <div className="text-center py-16 bg-white dark:bg-surface-900 rounded-2xl border border-surface-200 dark:border-surface-700">
                <TrendingUp className="w-16 h-16 mx-auto mb-4 text-gray-300 dark:text-gray-600" />
                <h3 className="font-poppins font-semibold text-lg mb-2 text-gray-900 dark:text-white">
                  Henüz Entry Yok
                </h3>
                <p className="text-gray-600 dark:text-gray-400 mb-6">
                  İlk entry'yi sen yaz ve topluluğu başlat!
                </p>
                <Link
                  to="/create-topic"
                  className="inline-flex items-center gap-2 px-6 py-3 bg-mavi-500 hover:bg-mavi-600 text-white rounded-xl font-poppins font-semibold transition-all"
                >
                  Yeni Başlık Oluştur
                </Link>
              </div>
            )}
          </motion.div>
        )}
      </div>
    </motion.div>
  )
}